export const getBuildingDescription = (buildingType: string): string => {
  switch (buildingType) {
    case "build/token_house":
      return "The Token House is the heart of your settlement’s economy. It passively generates tokens, which are essential for expanding your village, constructing buildings, and making upgrades.";
    case "build/iron_mine":
      return "The Iron Mine is a crucial source of metal, extracting iron from deep underground. This resource is essential for constructing advanced buildings, crafting tools, and strengthening your defenses.";
    case "build/lumber_mill":
      return "The Lumber Mill processes freshly cut logs into usable wood, a fundamental material for constructing buildings and crafting various tools.";
    case "build/farm":
      return "The Farm is the backbone of food production in your settlement. Farmers cultivate vast fields of wheat, ensuring a steady supply of grain for further processing.";
    case "build/mill":
      return "The Mill grinds harvested wheat into fine flour, an essential ingredient for baking bread. It serves as a key part of the food supply chain.";
    case "build/bakery":
      return "The Bakery transforms flour into freshly baked bread, providing nourishment for your people. A well-functioning bakery ensures a happy and productive population.";
    case "build/ranch":
      return "The Ranch is home to cattle, which provide both meat and milk. Properly managed ranches ensure a sustainable source of animal products for your settlement.";
    case "build/milk_barn":
      return "The Milk Barn is dedicated to processing fresh milk from cattle. This dairy facility ensures a steady supply of milk for consumption and further processing.";
    case "build/dairy_cellar":
      return "The Dairy Cellar is where milk is aged and processed into cheese. This facility enhances food storage capabilities and increases the value of dairy products.";
    case "build/builders_hut":
      return "The Builder’s Hut is the headquarters for all construction efforts. Skilled builders operate from here, accelerating the construction and upgrading of various structures.";
    case "build/lab":
      return "The Laboratory is the center of innovation in your settlement. It generates research points, allowing you to unlock new technologies and advance your civilization.";

    default:
      return "Unknown building type. This structure does not exist in the current settlement.";
  }
};
